import { GigTheme } from '../../types/gig/interfaces';

export const isExperientialGigTheme = (gigTheme: GigTheme) => gigTheme === 'experiential';
